/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
let isTouchDevice = !!("ontouchstart" in window);

// function is_touch_enabled() {
//   return ( 'ontouchstart' in window ) ||
//          ( navigator.maxTouchPoints > 0 ) ||
//          ( navigator.msMaxTouchPoints > 0 );
// }

const is_touch_enabled = () => {
  try {
    //We try to create touch event. It would fail for desktops and throw an error.
    document.createEvent("TouchEvent");
    return true;
  } catch (e) {
    return false;
  }
};

if (is_touch_enabled()) {
  document.querySelector("body").classList.add("is-touch");
}

function is_mobile() {
  if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
    isMobile = true;
  } else {
    isMobile = false;
  }
}

/*  ==========================================================================
		GENERAL - Used to make sure that javascript runs after back history 
		========================================================================== */

window.onunload = function () {};

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line--added):not(.btn)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line--added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
      // updating the scroll due to change to layout
      locomotiveScrollUpdate();
    })
  );
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
var lazyLoadInstance = new LazyLoad({
  callback_loaded: lazyLoadCompleted
});

function lazyLoadCompleted() {
  // Lazy load complete - reload masonry grids
  reloadMasonryGrids();

  setTimeout(function () {
    // Lazy load complete - upfate locomotive scroll
    locomotiveScrollUpdate();
  }, 500);
}

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

const plyrsInit = function () {
  const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

  if (!plyrs) {
    return;
  }

  plyrs.forEach(function (el) {
    let plyr = el.querySelector(".mediavideo__video");

    let videoMuted = false;
    if (el.classList.contains("mediavideo--ctp-auto")) {
      let videoMuted = true;
    }

    new Plyr(plyr, {
      controls: ["play", "progress", "mute", "current-time", "fullscreen"],

      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true
      },

      hideControls: true,
      invertTime: false,
      muted: videoMuted,
      tooltips: { controls: false, seek: false }
    });
  });
}; // plyrsInit();

plyrsInit();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */
const fancyboxInit = function () {
  const fancyboxOptions = {
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false, // Disable thumbnails
    on: {
      done: (fancybox, slide) => {
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
      }
    }
  };

  Fancybox.bind("[data-fancybox]", fancyboxOptions);
}; // fancyboxInit();
fancyboxInit();

/*  ==========================================================================
    MEDIA - Enable masonry grids option on media module
    ========================================================================== */

const $masonrygrids = $(".module--media--masonry");

if ($masonrygrids.length > 0) {
  gridsInit();
}

function gridsInit() {
  $masonrygrids.each(function () {
    var $el = $(this);
    $el.find(".row").masonry({
      // set itemSelector so .grid-sizer is not used in layout
      itemSelector: ".col",
      // use element for option
      columnWidth: ".col",
      percentPosition: true
    });
  });
} // grids__init()

function reloadMasonryGrids() {
  if ($masonrygrids.length > 0) {
    $masonrygrids.each(function () {
      var $el = $(this);
      $el.find(".row").masonry("reloadItems");
      $el.find(".row").masonry("layout");
    });
  }
}

/*  ==========================================================================
    FORMS - Contact Form toggle
    ========================================================================== */

function contactFormSetup() {
  const contactFormOptions = document.querySelectorAll(".contactforms__option");

  if (!contactFormOptions) {
    return;
  }

  contactFormOptions.forEach(contactFormOptions =>
    contactFormOptions.addEventListener("click", function (e) {
      e.preventDefault();
      const formID = this.dataset.formid;
      let activeForm = document.getElementById("form__" + formID);
      let contactFormActiveOption = document.querySelector(".contactforms__option.active");
      let contactFormActiveForm = document.querySelector(".contactforms__form.active");

      contactFormActiveOption.classList.remove("active");
      contactFormActiveForm.classList.remove("active");

      this.classList.add("active");
      activeForm.classList.add("active");

      const formURL = new URL(window.location);
      formURL.searchParams.set("formid", formID);
      history.pushState({}, "", formURL);
    })
  );

  // const isAdvancedUpload = function() {
  //   let div = document.createElement('div');
  //   return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
  // }();

  jQuery(document).on("nfFormReady", function () {
    const stepsText = document.querySelectorAll(".contactform__description .step");

    const dropAreas = document.querySelectorAll(".file_upload-wrap");
    dropAreas.forEach(dropArea => {
      if (dropArea.querySelector(".nf-field-label")) {
        let height = dropArea.querySelector(".nf-field-label").offsetHeight;
        dropArea.parentNode.style.paddingTop = height + "px";
      }

      dropArea.setAttribute("draggable", "true");

      dropArea.addEventListener("dragover", () => {
        dropArea.classList.add("is-dragover");
      });
      dropArea.addEventListener("dragleave", () => {
        dropArea.classList.remove("is-dragover");
      });
      dropArea.addEventListener("drop", () => {
        dropArea.classList.remove("is-dragover");
      });
    });
  });
}

contactFormSetup();

/*  ==========================================================================
    Blog Post - Calculate Read Time
    ========================================================================== */

function calculatePostReadTime() {
  const postContent = document.querySelector(".post-module--text-content");

  if (postContent) {
    const wordsPerMinute = 250; // Adjust this value based on your desired reading speed
    const contentAreas = document.querySelectorAll(".contentarea");
    const readingTimeText = document.querySelector(".reading-time__text");
    let totalReadTime = 0;

    contentAreas.forEach(function (contentArea) {
      const wordCount = contentArea.textContent.trim().split(/\s+/).length;
      const readTime = wordCount / wordsPerMinute;
      totalReadTime += readTime;
    });

    totalReadTime = Math.ceil(totalReadTime);

    if (readingTimeText) {
      readingTimeText.textContent = totalReadTime + " min read";
    }
  }
}

calculatePostReadTime();

/*  ==========================================================================
    Post Accordion - Calculate Widths
    ========================================================================== */

function setupAccordionHovers(accordionRow, accordionCols, firstColWidth) {
  if (!accordionCols) {
    return;
  }
  accordionCols.forEach(item => {
    let wrap = item.querySelector(".tile__wrap");
    wrap.style.width = firstColWidth + "px";

    let tileWidth = item.querySelector(".tile").offsetWidth;

    item.addEventListener("mouseover", event => {
      accordionCols.forEach(otheritem => {
        otheritem.querySelector(".tile").style.width = "100%";
        otheritem.querySelector(".tile").style.transform = "translateX(0)";
      });

      item.querySelector(".tile").style.width = firstColWidth + "px";
      item.querySelector(".tile").style.transform = "translateX(" + (tileWidth - firstColWidth) + "px)";
    });
  });

  accordionRow.addEventListener("mouseleave", event => {
    accordionCols.forEach(otheritem => {
      otheritem.querySelector(".tile").style.width = "100%";
      otheritem.querySelector(".tile").style.transform = "translateX(0)";
    });
  });
}

function postAccordionInit() {
  // All this is ignored on MOBILE by hardcoding the css values

  const accordionRows = document.querySelectorAll(".module--featured--accordion .row");

  if (!accordionRows) {
    return;
  }

  accordionRows.forEach(accordionRow => {
    const accordionCols = accordionRow.querySelectorAll(".col--accordion");
    let firstColWidth = accordionCols[0].offsetWidth;

    setupAccordionHovers(accordionRow, accordionCols, firstColWidth);

    window.addEventListener("resize", () => {
      firstColWidth = accordionCols[0].offsetWidth;
      setupAccordionHovers(accordionRow, accordionCols, firstColWidth);
      console.log("update width");
    });
  });
}

postAccordionInit();

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

  const loadmoreBtn = document.querySelector(".paging__loadmore");
  const loadmoreContainer = document.querySelector(".loadmore-container");

  const loadmoreLoadPostsMultiplePages = function (pages) {

    if(pages && pages > 1){

      //Stopping default scroll back to previous position
      history.scrollRestoration = 'manual';

      const currentPage = new URL(window.location);
  
      //Creating an array on page numbers to map it
      var list = [];
      for (var i = 1; i < pages; i++) {
        list.push(i);
      }
  
      // Initialising the array of posts pages
      var postsHTML = [];

      const button = loadmoreBtn;
      const buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

      // Array of ajax calls
      var allAJAX = list.map(function(page){
          const data = {
            action: "loadmore",
            query: php_variables.posts, // that's how we get params from wp_localize_script() function
            page: page
          };
          //Updating the url to mtch the page number
          currentPage.searchParams.set('pagenum', page);
          return $.ajax({
            url: php_variables.ajax_url, // AJAX handler
            data: data,
            type: "POST",
            success: function (data) {
              postsHTML[page] = data;
            }
          });
      });

      // Waiting for all the ajax calls to be finished before proceeding
      Promise.all(allAJAX).then(function() {
        // Update current page variable
        php_variables.current_page = pages;

        button.textContent = buttonText; // set back to previous button text

        // Adding the new tiles to the dom
        list.map(page => {
          if(postsHTML[page]){
              loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
            }
        });

        // Updating the href for the loadmore button
        const nextPage = new URL(window.location);
        nextPage.searchParams.set('pagenum', parseInt(pages) + 1);
        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
          
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);

        // Scrolling the page to the last known position
        if(localStorage.getItem("scrollPosition")) {
          window.scroll({
            top: parseInt(localStorage.getItem("scrollPosition"), 10),
            behavior: "instant"
          });
        }
        
      });
    }
  };
  
  const loadmoreLoadPosts = function (e) {

    e.preventDefault(); // Preventing the a tag from redirecting to the page
    
    const button = this;
    const data = {
      action: "loadmore",
      query: php_variables.posts, // that's how we get params from wp_localize_script() function
      page: php_variables.current_page
    };
    let buttonText; // create variable to store button text
  
    // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
    $.ajax({
      url: php_variables.ajax_url, // AJAX handler
      data: data,
      type: "POST",
      beforeSend: function (xhr) {
        buttonText = button.textContent; // store current button text
        button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
      },
      success: function (data) {
        if (data) {
          button.textContent = buttonText; // set back to previous button text 
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
          
          php_variables.current_page++;

          // Only push state to set the last page number or if there is more pages to load
          const currentPage = new URL(window.location);
          
          if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
            currentPage.searchParams.set('pagenum', php_variables.current_page);
            history.pushState({}, "", currentPage);
          }

          //Updating the loadmore link
          const nextPage = new URL(window.location);
          nextPage.searchParams.set('pagenum', parseInt(php_variables.current_page) + 1);

          button.href = nextPage;
  
          // if last page, remove the button..
          if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
            button.style.display = "none";
          }
          // Re-init links to make sure linklines on newly loaded content still work
          linksInit();
          // Re-init lazy load
          lazyLoadInstance.update(); // reinit lazy load after clones
          // Re-init effects
          const effects = document.querySelectorAll(".effect");
          effectsInit(effects);
          
        } else {
          button.style.display = "none"; // if no data, remove the button as well
        }
      }
    });
  }; // loadmoreLoadPosts();
  
  const loadmoreInit = function () {
    if (!loadmoreBtn) {
      return;
    }
    /** When adding fitering you will need to move this part into the filtering call */
    // Checking if the page paramenter is set
    const currentPage = new URL(window.location);
    let currentPageNum = currentPage.searchParams.get('pagenum');

    //If there is more than one page to load
    if(currentPageNum && currentPageNum > 1){    
      currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
      loadmoreLoadPostsMultiplePages(currentPageNum);
    }
    /** -end- */

    // Saving the scroll position before unload
    window.addEventListener("pagehide", function(e) {
      var scrollPosition = window.scrollY;
      localStorage.setItem("scrollPosition", scrollPosition);
    });
    
    loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
  }; // loadmoreInit();
  
  loadmoreInit();


/*  ==========================================================================
    AJAX - AJAX work filter
    ========================================================================== */

  const filters = document.querySelector(".filters"),
        filterForm = document.querySelector(".filters__form"),
        filterClearAll = document.getElementById("filters__clearall"),
        portfolioList = document.getElementById("portfoliolist"),
        filterCheckboxes = document.querySelectorAll(".filters__fieldset__field input");

  const dropDownLink = document.querySelector(".filters__dropdown"), 
        dropDownLinkText = document.querySelector(".filters__dropdown span"),
        closeDropdown = document.querySelector(".filters__close");


  // Get current from filters data
  const filterGetFormData = function () {

    let filter_data = {};

    filter_settings.filters.forEach(function (el) {
      let checkedOptions = document.querySelectorAll('input[type="radio"][name=' + el.name + "]:checked");

      if(checkedOptions.length > 0){  
        filter_data[el.name] = [...checkedOptions].map(x => x.value);
      }
    });

    return filter_data;
  };

  const filterUpdateURL = function (filterData) {
    let url_params = "";

    for (const [key, value] of Object.entries(filterData)) {
      if (value.length > 0) {
        if (url_params === "") {
          url_params = url_params + "?";
        } else {
          url_params = url_params + "&";
        }
        // Convert values to comma seperated string
        let values = Object.keys(value)
          .map(function (k) {
            return value[k];
          })
          .join(",");
        url_params = url_params + "filter_" + key + "=" + values;
      }
    }
      
    let currentPageUrl = window.location.href.split("?")[0];
    let newUrl = currentPageUrl + url_params;
    window.history.pushState({ path: newUrl }, "", newUrl);
  };

  const filterGetPosts = function (updateURL) {

    // Getting the forma data
    let filterData = filterGetFormData();
    let pageData = false;

    if (filterData) {

      // This will need updating if we allow for multiple filters to be applied
      let activeElements = document.querySelectorAll('.filters__fieldset__field input[type="radio"]:checked');

      if(activeElements.length > 0 && dropDownLinkText){
        dropDownLinkText.innerHTML = activeElements[0].nextElementSibling.textContent;
      }else{
        dropDownLinkText.innerHTML = 'All work';
      }

      if(Object.keys(filterData).length > 0){
        filterClearAll.classList.remove('active');
      }else{
        filterClearAll.classList.add('active');
      }

      // Update url
      if(updateURL){
        filterUpdateURL(filterData);
      }

      // Scroll to filtering system
      window.scrollTo({
        top: document.querySelector(".col--filter").offsetTop,
        behavior: "smooth"
      });

      // Start filtering
      portfolioList.style.opacity = 0;
      setTimeout(function() {
        portfolioList.classList.add("filtering");
      }, 200);

      // Remove all active descriptions
      const activeDescriptions = document.querySelectorAll('.category__description.active');
      activeDescriptions.forEach(item => {
        item.classList.remove('active');
      });
    

      // Trigger ajax
      let data = {
        action: "filter",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
        page: php_variables.current_page,
        filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
        filter_data: filterData
      };

      $.ajax({
        url: php_variables.ajax_url,
        data: data, // form data
        dataType: "json", // this data type allows us to receive objects from the server
        type: "POST",
        success: function (data) {
          // when filter applied:
          // set the current page to 1
          php_variables.current_page = 1;

          // set the new query parameters
          php_variables.posts = data.posts;

          // set the new max page parameter
          php_variables.max_page = data.max_page;

          // insert the posts to the container
          if (portfolioList) {
            portfolioList.innerHTML = data.content;
            // Finish filtering
            portfolioList.style.opacity = 1;
            portfolioList.classList.remove("filtering");
          }

          if(activeElements.length > 0){
            // Check if the category selected has a description
            const currentCatDescription = document.getElementById('description-'+activeElements[0].value);
            if(currentCatDescription){
              currentCatDescription.classList.add('active');
            }
          }

          //update other scripts
          lazyLoadInstance.update();
          locomotiveScrollUpdate();
          
        },
        error: function (data) {}
      });
    }else{
      if(dropDownLinkText){
        dropDownLinkText.innerHTML = 'All work';
      }
    }
  };

  const filterSetupClearAll = function () {
    
    filterClearAll.addEventListener("click", function () {
      // Uncheck all inputs
      filterCheckboxes.forEach(el => (el.checked = false));

      // Trigger filter
      filterGetPosts(true);

      dropDownLink.classList.remove('active');
      document.body.classList.remove('workfilteropen');
      
      filterClearAll.classList.add('active');
      
    });
  };

  // Mobile version of the filter menu
  const filterDropdownInit = function () {

    const workFilterItems = document.querySelectorAll(".filters__fieldset__field input, .filters__clearall");

    // Adding Event Listeners
    if(dropDownLink){
      dropDownLink.addEventListener("click", function (e) {
        e.preventDefault();
        dropDownLink.classList.toggle('active');
        document.body.classList.toggle('workfilteropen');
      });
      if(closeDropdown){
        closeDropdown.addEventListener("click", function (e) {
          e.preventDefault();
          dropDownLink.classList.remove('active');
          document.body.classList.remove('workfilteropen');
        });
      }
    } 
  };

  // Init Filter on posts pages
  const filterInit = function () {

    if (filterForm && filterForm.length) {
      // Get Posts based on Filter Form Data
      filterGetPosts(false);

      // Filter on submit
      filterForm.addEventListener("submit", function (e) {
        // Stop the form from submitting
        e.preventDefault();

        // Call the filtering post function
        filterGetPosts(true);
      });

      const filterCheckboxes = filterForm.querySelectorAll(".filters__fieldset__field input");

      filterCheckboxes.forEach(checkbox => {
        checkbox.addEventListener("change", function (evt) {
          filterCheckboxes.forEach(el => {
            if(el !== this){
              el.checked = false;
            }
          });
          // Update Mobile Navigation
          dropDownLinkText.innerHTML = this.nextElementSibling.textContent;
          dropDownLink.classList.remove('active');
          document.body.classList.remove('workfilteropen');

          // Submit for on checkbox click
          filterGetPosts(true);
        });
      });

      // Clear all
      filterSetupClearAll();

      // Mobile Navigation
      filterDropdownInit();

    }
  };

  filterInit();
/*  ==========================================================================
		GENERAL - Locomotive Scroll
		========================================================================== */

// const body = document.body;
// const backToTop = document.querySelector(".back-to-top");
// const opacityClass = "opacity-0";
// const visibilityClass = "invisible";

const locomotiveScroll = false;

if (document.querySelector("[data-scroll-container]")) {
  const locomotiveScroll = new LocomotiveScroll({
    el: document.querySelector("[data-scroll-container]"),
    smooth: true,
    offset: [150, -150]
  });

  /*  ==========================================================================
	Navigation hide header after scroll - Shows again if user hovers near top
  Progress Bar width on scroll with page, Post single page only
	========================================================================== */
  const siteheader = document.querySelector(".siteheader");
  const siteheaderPadderHeight = document.querySelector(".siteheader--padder").offsetHeight;

  locomotiveScroll.on("scroll", position => {
    let scrollLimit = position.limit.y;

    if (position.scroll.y > siteheaderPadderHeight) {
      siteheader.classList.add("siteheader--navhidden");
      // if (progressBarContainer) {
      //   progressBarContainer.style.top = "0";
      // }
    } else {
      siteheader.classList.remove("siteheader--navhidden");
      // if (progressBarContainer) {
      //   progressBarContainer.style.top = siteheaderPadderHeight + "px";
      // }
    }
  });

  //Fix for Height Update when Dom Elements change Height
  new ResizeObserver(() => locomotiveScroll.update()).observe(document.querySelector("[data-scroll-container]"));

  setTimeout(function () {
    // loco refresh here
    locomotiveScroll.update();
    Waypoint.refreshAll();
  }, 600);
}

function locomotiveScrollUpdate() {
  if (locomotiveScroll && document.querySelector("[data-scroll-container]")) {
    locomotiveScroll.update();
  }
}

// If there is a ninja form in the page
if (document.querySelectorAll(".nf-form-cont").length) {
  // Refresh the locomotive scroll on ninja form ready event so that it detects the height of the ninja form
  jQuery(document).on("nfFormReady", function () {
    locomotiveScrollUpdate();
  });
}

/*  ==========================================================================
    Animate in on scroll for post page elements
    ========================================================================== */

window.addEventListener("scroll", function () {
  const siteheader = document.querySelector(".siteheader");
  const siteheaderPadderHeight = document.querySelector(".siteheader--padder").offsetHeight;
  const postControls = document.querySelector(".post-controls");
  const pageheaderMedia = document.querySelector(".pageheader__media");
  const pageheaderBody = document.querySelector(".pageheader__body");
  const postFooter = document.querySelector(".post-footer");
  const controlItems = document.querySelectorAll(".control-item");
  const siteFooter = document.querySelector(".sitefooter");
  const progressBarContainer = document.getElementById("progress-bar-container");

  // Animate post controls in and out
  // Check if .post-controls exists
  if (postControls) {
    let scrollpos = window.scrollY;
    let docHeight = document.querySelector(".main__wrap").offsetHeight;

    let pageheaderMediaPadderHeight = pageheaderMedia ? pageheaderMedia.offsetHeight : 0;
    let pageheaderBodyPadderHeight = pageheaderBody.offsetHeight;
    let postFooterHeight = postFooter.offsetHeight;
    let siteFooterHeight = siteFooter.offsetHeight;
    let controlsTrigger = pageheaderMediaPadderHeight;
    let controlsTriggerEnd = document.documentElement.scrollHeight - postFooterHeight - siteFooterHeight - 500;

    controlItems.forEach((item, index) => {
      if (controlsTrigger < scrollpos && controlsTriggerEnd > scrollpos) {
        item.classList.remove("out", "slide-out");
        item.classList.add("in", "slide-in");
      } else {
        item.classList.remove("slide-in");
        item.classList.add("slide-out");
        setTimeout(() => {
          item.classList.remove("in");
          item.classList.add("out");
        }, 300); // animation time of 0.3s
      }
    });
  }

  // Progress Bar Update
  if (document.getElementById("progress-bar")) {
    const scrollTop = window.scrollY;
    const docHeight = document.querySelector(".main__wrap").offsetHeight;
    const winHeight = window.innerHeight;
    let postFooterHeight = postFooter.offsetHeight;
    let siteFooterHeight = siteFooter.offsetHeight;

    // Adjust document height by subtracting footer heights
    let adjustedDocHeight = docHeight - postFooterHeight - siteFooterHeight;

    const scrollPercent = (scrollTop / (adjustedDocHeight - winHeight)) * 100;

    document.getElementById("progress-bar").style.width = scrollPercent + "%";
  }
});

/*  ==========================================================================
    Custom Cursor
    ========================================================================== */

var cursor = {
  delay: 8,
  _x: 0,
  _y: 0,
  endX: window.innerWidth / 2,
  endY: window.innerHeight / 2,
  cursorVisible: true,
  cursorEnlarged: false,
  $dot: document.querySelector(".cursor-dot"),

  init: function () {
    // Set up element sizes
    this.dotSize = this.$dot.offsetWidth;
    this.setupEventListeners();
    this.animateDot();
  },

  setupEventListeners: function () {
    var self = this;

    // Anchor hovering
    document.querySelectorAll("a:not(.btn)").forEach(function (el) {
      el.addEventListener("mouseover", function () {
        self.cursorEnlarged = true;
        self.toggleCursorSize();
      });
      el.addEventListener("mouseout", function () {
        self.cursorEnlarged = false;
        self.toggleCursorSize();
      });
    });
    // Button hovering
    document.querySelectorAll(".btn").forEach(function (el) {
      el.addEventListener("mouseover", function () {
        self.cursorEnlarged = true;
        self.toggleCursorBtn();
      });
      el.addEventListener("mouseout", function () {
        self.cursorEnlarged = false;
        self.toggleCursorBtn();
      });
    });

    // Click events
    document.addEventListener("mousedown", function () {
      self.cursorEnlarged = true;
      self.toggleCursorSize();
    });
    document.addEventListener("mouseup", function () {
      self.cursorEnlarged = false;
      self.toggleCursorSize();
    });

    document.addEventListener("mousemove", function (e) {
      // Show the cursor
      self.cursorVisible = true;
      self.toggleCursorVisibility();

      // Position the dot
      self.endX = e.clientX;
      self.endY = e.clientY;
      self.$dot.style.top = self.endY + "px";
      self.$dot.style.left = self.endX + "px";
    });

    // Hide/show cursor
    document.addEventListener("mouseenter", function (e) {
      self.cursorVisible = true;
      self.toggleCursorVisibility();
      self.$dot.style.opacity = 1;
    });

    document.addEventListener("mouseleave", function (e) {
      self.cursorVisible = true;
      self.toggleCursorVisibility();
      self.$dot.style.opacity = 0;
    });
  },

  animateDot: function () {
    var self = this;

    self._x += (self.endX - self._x) / self.delay;
    self._y += (self.endY - self._y) / self.delay;
    self.$dot.style.top = self._y + "px";
    self.$dot.style.left = self._x + "px";

    requestAnimationFrame(this.animateDot.bind(self));
  },

  toggleCursorSize: function () {
    var self = this;
    if (self.cursorEnlarged) {
      self.$dot.style.transform = "translate(-50%, -50%) scale(2)";
    } else {
      self.$dot.style.transform = "translate(-50%, -50%) scale(1)";
    }
  },

  toggleCursorBtn: function () {
    var self = this;
    if (self.cursorEnlarged) {
      self.$dot.style.transform = "translate(-50%, -50%) scale(3)";
    } else {
      self.$dot.style.transform = "translate(-50%, -50%) scale(1)";
    }
  },

  toggleCursorVisibility: function () {
    var self = this;
    if (self.cursorVisible) {
      self.$dot.style.opacity = 1;
    } else {
      self.$dot.style.opacity = 0;
    }
  }
};

if (document.querySelectorAll(".nf-form-cont").length) {
  // load cursor on ninja form ready event so that it works on ninja forms submit button
  // If there is a ninja form in the page
  jQuery(document).on("nfFormReady", function () {
    if (!isMobile && !is_touch_enabled()) {
      cursor.init();
    }
  });
} else {
  // if not, just load cursor if not mobile
  if (!isMobile && !is_touch_enabled()) {
    cursor.init();
  }
}

/*  ==========================================================================
    Page Transition
============================================================================ */

const transitionLinks = document.querySelectorAll(
    ".tile--work .tile__link, .sitenav__link, .cta__btn, .sitefooter__link, .pageheader__cta .btn, a.text-link"
  ),
  pageTransition = document.querySelector(".pagetransition");

if (transitionLinks && pageTransition) {
  transitionLinks.forEach((elem, index) => {
    elem.addEventListener("click", function (e) {
      if (
        this.href !== window.location.href &&
        this.href !== window.location.href + "#" &&
        this.target !== "_blank" &&
        !this.hasAttribute("data-fancybox")
      ) {
        if (!isMobile && !is_touch_enabled()) {
          pageTransition.classList.add("active");
        }
        if (currentPage) {
          currentPage.classList.remove("loaded");
        }
      }
    });
  });
}

/*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

const default_animation_speed = 1.5;

const elClass = "marquee";
const innerClass = "marquee__wrap";

const marqueeElements = document.querySelectorAll(".marquee");

const marquee__reset = function (el) {
  const wrapElements = el.querySelectorAll("." + innerClass);

  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  // If the width of the wrap is less than the minimum width we need to duplicate existing tiles
  if (wrapElements[0].offsetWidth < minWidth) {
    // Getting the orginal items
    const originalNumItems = el.dataset.count ? el.dataset.count : 1;

    let orginalTiles = "";

    const tiles = wrapElements[0].querySelectorAll(".marquee__tile");

    for (let index = 0; index < originalNumItems; index++) {
      orginalTiles += '<div class="marquee__tile">' + tiles[index].innerHTML + "</div>";
    }

    //Calculating how many times do we need to repeat the original tiles based of the width of the tile
    const numTiles = tiles.length;
    const textWidth = tiles[0].offsetWidth * numTiles;
    const timesToRepeat = Math.ceil((minWidth - wrapElements[0].offsetWidth) / textWidth);

    //Adding the extra tiles to the three wraps
    for (let index = 0; index < timesToRepeat; index++) {
      wrapElements[0].innerHTML += orginalTiles;
      wrapElements[1].innerHTML += orginalTiles;
      wrapElements[2].innerHTML += orginalTiles;
    }
  }
};

const marquee__resize = function (el) {
  // Check if the marquee is large enought for the space
  marquee__reset(el);

  // Check if element has custom speed or default
  let animation_speed = default_animation_speed;
  if (el.dataset.speed) {
    animation_speed = el.dataset.speed;
  } else {
    animation_speed = default_animation_speed;
  }

  const wrapElements = el.querySelectorAll("." + innerClass);

  // Calculate the animation time and delay for each wrap
  let linelength = wrapElements[0].offsetWidth;
  let distance = linelength;
  let speed = animation_speed * 0.01;
  let duration = distance / speed;

  let delay = 0 - duration / 3;

  wrapElements.forEach(function (wrap, index) {
    let count = index + 1;
    wrap.style.animationDuration = duration + "ms";
    wrap.style.animationDelay = delay * count + "ms";
  });
};

const marquee__init = function () {
  if (!marqueeElements) {
    return;
  }

  // Repeating Logos and Text to make sure it fills the width of the view port
  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  marqueeElements.forEach(function (el) {
    // Wrapping the tiles
    el.innerHTML = "<div class='" + innerClass + "'>" + el.innerHTML + "</div>";

    // Duplicating the wrap element
    const repeatingTextClone = el.querySelector(".marquee__wrap").cloneNode(true),
      repeatingTextClone2 = el.querySelector(".marquee__wrap").cloneNode(true);

    repeatingTextClone.ariaHidden = "true";
    repeatingTextClone2.ariaHidden = "true";

    el.appendChild(repeatingTextClone);
    el.appendChild(repeatingTextClone2);

    // Setup animation times
    marquee__resize(el);

    // Once everything is set up, add "loaded" class
    el.classList.add(elClass + "--loaded");
  });
};
marquee__init();

// const logosMarqueeInit = function () {
//   if (!logosMarquee) {
//     return;
//   }

//   window.addEventListener("resize", function () {
//     marquee__resize(logosMarquee);
//   });

//   // Repeating Logos and Text to make sure it fills the width of the view port
//   const viewportWidth = window.innerWidth;
//   const minWidth = (viewportWidth * 1) / 2;

//   const tiles = logosMarquee.querySelectorAll(".marquee__tile");
//   const numTiles = tiles.length;
//   const textWidth = tiles[0].offsetWidth * numTiles;

//   // Wrapping the tiles
//   logosMarquee.innerHTML = "<div class='" + innerClass + "'>" + logosMarquee.innerHTML + "</div>";

//   // Duplicating the wrap element
//   const repeatingTextClone = logosMarquee.querySelector(".marquee__wrap").cloneNode(true),
//     repeatingTextClone2 = logosMarquee.querySelector(".marquee__wrap").cloneNode(true);

//   repeatingTextClone.ariaHidden = "true";
//   repeatingTextClone2.ariaHidden = "true";

//   logosMarquee.appendChild(repeatingTextClone);
//   logosMarquee.appendChild(repeatingTextClone2);

//   // Force all lazy images within carousels to load immediately, otherwise they wont load
//   // const marquee_lazyimgs = document.querySelectorAll(".marquee .lazy");
//   // marquee_lazyimgs.forEach(img => {
//   //   LazyLoad.load(img);
//   //   console.log(img);
//   // });

//   // Setup animation times
//   marquee__resize(logosMarquee);

//   // Once everything is set up, add "loaded" class
//   logosMarquee.classList.add(elClass + "--loaded");
// };

// // Defer loading this code until after page load
// window.addEventListener("load", logosMarqueeInit);

/*  ==========================================================================
    Project Tiles + Project Single animation
============================================================================ */

const singleProject = document.querySelector(".main--singleproject");

if (singleProject) {
  const pageheaderMedia = document.querySelector(".pageheader__media .component");

  if (pageheaderMedia) {
    const pageheaderMediaImage = pageheaderMedia.querySelector(".mediaimg__img");
    if (pageheaderMediaImage) {
      let paddingtop = aspectRationCalculation(pageheaderMediaImage.width, pageheaderMediaImage.height);
      if (paddingtop) {
        pageheaderMedia.style.paddingTop = paddingtop;
        pageheaderMedia.style.height = 0;
        pageheaderMedia.classList.add("ready");
      }
    }
  }

  setTimeout(function () {
    document.documentElement.classList.add("isloading");
    setTimeout(function () {
      document.documentElement.classList.add("isready");
      locomotiveScrollUpdate();
    }, 200);
  }, 300);
}

function aspectRationCalculation(w, h) {
  var output = ((Math.round(h) / Math.round(w)) * 100).toFixed(2);
  if (output > 0) {
    return output.replace(".00", "") + "%";
  } else {
    return false;
  }
}

/* ==========================================================================
    Module Text Reveal 
============================================================================ */

const revevalColumns = document.querySelectorAll(".col--hiddencontent");

const revealTextResize = function (item) {
  let highestNumber = false;
  if (item) {
    let defaultText = item.querySelector(".contentarea--visible");
    let hoverText = item.querySelector(".contentarea--hover");
    let contentareasEl = item.querySelector(".contentareas");

    if (defaultText && hoverText && contentareasEl) {
      let defaultTextHeight = defaultText.offsetHeight; //.offsetHeight();
      let hoverTextHeight = item.querySelector(".contentarea--hover").offsetHeight; //.offsetHeight();

      highestNumber = defaultTextHeight > hoverTextHeight ? defaultTextHeight : hoverTextHeight;

      if (highestNumber) {
        contentareasEl.style.height = highestNumber + "px";
      }
    }
  }
};

const resizeObserver = new ResizeObserver(entries => {
  for (const entry of entries) {
    revealTextResize(entry.target);
  }
});

const revealTextInit = function (revevalColumns) {
  if (!revevalColumns) {
    return;
  }

  revevalColumns.forEach(item => {
    revealTextResize(item);
    resizeObserver.observe(item);
  });
}; // accordionInit();
revealTextInit(revevalColumns);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      margin: 20,
      items: 1,
      slideBy: 3,
      navText: ["<span class='arrow arrow--left'></span>", "<span class='arrow arrow--right'></span>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
        
        // Lazy load complete - upfate locomotive scroll
        locomotiveScrollUpdate();
      }, 500);
    });
  
    setTimeout(function () {
      // Carosule load complete - update locomotive scroll
      locomotiveScrollUpdate();
    }, 500);
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight - siteHeaderBd.getBoundingClientRect().height;
  mobnav.style.height = `${mobnavHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();

    let mobnavHeight = 0;
    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      mobnavSetHeight();
      body.classList.add(mobnavOpenclass);
    } else {
      // IT'S OPEN...
      mobnav.style.height = 0;
      body.classList.remove(mobnavOpenclass);
    }
  });
}; // mobnavInit()
mobnavInit();

// On resize check mobnav height is still right
const mobnavResize = function () {
  let mobnavHeight = 0;
  if (body.classList.contains(mobnavOpenclass)) {
    mobnavSetHeight();
  }
}; // mobnavResize()

window.addEventListener(
  "resize",
  function (event) {
    mobnavResize();
  },
  true
);

/*  ==========================================================================
	NAVIGATION - hide header after scroll 
  - Shows again if user hovers near top
	========================================================================== */
const siteheader = document.querySelector(".siteheader");
const siteheaderPadder = document.querySelector(".siteheader--padder");
const waypoints = new Waypoint({
  element: siteheaderPadder,
  handler: function (direction) {
    if (direction === "down") {
      siteheader.classList.add("siteheader--navhidden");
    } else {
      siteheader.classList.remove("siteheader--navhidden");
    }
  },
  offset: "-5"
});

/*  ==========================================================================
	NAVIGATION - Fade in
	========================================================================== */

if (siteheader) {
  setTimeout(function () {
    siteheader.classList.add("loaded");
  }, 100);
}

/*  ==========================================================================
	NAVIGATION - Current items class animation
	========================================================================== */

const currentPage = document.querySelector(".sitenav__link--current");
if (currentPage) {
  setTimeout(function () {
    currentPage.classList.add("loaded");
  }, 1000);
}

/*  ==========================================================================
	NAVIGATION - Showreel button setup
	========================================================================== */

const showreelURL = php_variables.site_url + "/showreel/";
if (showreelURL) {
  //Checking for link that contain the showreel url
  const showreelLinks = document.querySelectorAll("[href='" + showreelURL + "']");

  showreelLinks.forEach(link => {
    // Adding the fancybox paramenters
    link.setAttribute("data-fancybox", "");
    link.setAttribute("data-type", "ajax");
    link.setAttribute("data-filter", "#main--showreel");
  });
}

/*  ==========================================================================
		NAVIGATION - Keyboard navigation
		========================================================================== */

onkeyup = event => {
  let activeElement = document.activeElement;

  if (siteheader.contains(activeElement)) {
    siteheader.classList.add("visible");
  } else {
    siteheader.classList.remove("visible");
  }
};

/*  ==========================================================================
	CARDGRID - cardgrid setup for homepage

  =   Card grid scroll: full script in vendor/cardgridscroll
	========================================================================== */

let animationSpeed = 300, 
  desktopBreakpoint = 700,
  windowWidth = window.innerWidth,
  windowHeight = window.innerHeight;

function setWindowDimensions() {
  windowWidth = window.innerWidth;
  windowHeight = window.innerHeight;
}

const cardGridDesktop = document.querySelector(".cardgrid--desktop");
const cardGridMobile = document.querySelector(".cardgrid--mobile");
const cardGridWrapper = document.querySelector(".cardgrid__wrapper");
let CardGridInstance = false;

function cardGridShow(){
  
  setTimeout(function() {
    cardGridDesktop.classList.remove("cardgrid--loading");
    
    setTimeout(function() {
      CardGridInstance.bindEvents();
      CardGridInstance.tick();
    }, animationSpeed * 2);
  }, animationSpeed);
}

let cardGridIsOn = false;

function cardGridInit(){

  if(!cardGridDesktop) { return; }

  //Setting up mouse inactivity message on the homepage
  let timeoutInMiliseconds = 8000;
  let timeoutId; 
 
  function startTimer() { 
      // window.setTimeout returns an Id that can be used to start and stop a timer
      timeoutId = window.setTimeout(whenInactive, timeoutInMiliseconds);
  }
  function resetTimer() { 
    window.clearTimeout(timeoutId);
    startTimer();
    document.querySelector('.cardgrid__notice').classList.remove('show');
  }
  
  function whenInactive() {
     // Show messeage on the homepage
    document.querySelector('.cardgrid__notice').classList.add('show');
  }

  function setupTimers () {
    document.addEventListener("mousemove", resetTimer, false);
    document.addEventListener("mousedown", resetTimer, false);
    document.addEventListener("keypress", resetTimer, false);
    document.addEventListener("touchmove", resetTimer, false);
     
    startTimer();
  }
  setupTimers();
  
  // Stop animation when user hover over the siteheader
  siteheader.addEventListener("mouseleave", function (event) {
    if(CardGridInstance && cardGridIsOn){
      CardGridInstance.addMouseListener();
    }
  });
  siteheader.addEventListener("mouseover", function (event) {
    if(CardGridInstance && cardGridIsOn){
      CardGridInstance.removeMouseListener();
    }
  });

  // Checking for window resize
  window.addEventListener("resize", function() {

    is_mobile();
    setWindowDimensions();

    if (!isMobile && !is_touch_enabled() && windowWidth > desktopBreakpoint ) {

      cardGridMobile.classList.remove('show');
      cardGridDesktop.classList.add('show');
      cardGridDesktop.classList.add("cardgrid--loading");
      
      // Creating the Grid instance if it does not exist
      if(!CardGridInstance && !cardGridIsOn){
        CardGridInstance = new CardGridMoves({
          el: cardGridWrapper,
          ease: 0.12
        });
      }
       // Adding tick and event listeners
      cardGridShow();
      cardGridIsOn = true;
    }else{
      cardGridMobile.classList.add('show');
      cardGridDesktop.classList.remove('show');
      
      // Removing tick and event listeners
      if(CardGridInstance){
        CardGridInstance.remove();
      }
      cardGridIsOn = false;
    }
    
  });

  // On page load if is desktop load cardgrid
  if (!isMobile && !isTouchDevice && windowWidth > desktopBreakpoint ) {

    cardGridMobile.classList.remove('show');
    cardGridDesktop.classList.add('show');
      
    if (cardGridWrapper) {

      CardGridInstance = new CardGridMoves({
          el: cardGridWrapper,
          ease: 0.12
      });

      cardGridIsOn = true;

      cardGridShow();   
    }
  }else{

    cardGridMobile.classList.add('show');
    cardGridDesktop.classList.remove('show');

    cardGridIsOn = false;
    setTimeout(function() { 
      cardGridDesktop.classList.remove("cardgrid--loading");
    }, animationSpeed);
  }
}

cardGridInit();


/* Feature Projects card grid */ 

const featureCardGrid = document.querySelector(".featurework__items");
const featureCardGridWrap = document.querySelector(".featurework__wrap");

let containerWidth, containerHeight, contentWidth, contentHeight;

function featureCardGridOnMouseMove(e){

  let x = e.pageX - featureCardGrid.getBoundingClientRect().left;
  let y = e.pageY - featureCardGrid.getBoundingClientRect().top;

  featureCardGridWrap.style.left = ((containerWidth - contentWidth) * ((x / containerWidth).toFixed(3)) ).toFixed(1) + "px";
  featureCardGridWrap.style.top = ((containerHeight - contentHeight) * ((y / containerHeight).toFixed(3))).toFixed(1) + "px";
}

function featureCardGridInit(){


  if(!featureCardGrid) { return; }


 featureCardGrid.addEventListener("mouseenter", (event) => {

    containerWidth = featureCardGrid.clientWidth;
    containerHeight = featureCardGrid.clientHeight;

    contentWidth = featureCardGridWrap.offsetWidth;
    contentHeight = featureCardGridWrap.offsetHeight;

    featureCardGrid.addEventListener("mousemove", featureCardGridOnMouseMove);
  });

  featureCardGrid.addEventListener("mouseleave", (event) => {
    // removing the listener when the mouse moves out of the frame
    featureCardGrid.removeEventListener("mousemove", featureCardGridOnMouseMove);
    
  });

}

featureCardGridInit();